import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { OnlineImportWarning } from './onlineImportService';

/**
 * What the values of a column could not decide — a date day or month first, a comma decimal or
 * thousands — said beside the mapping, in the online import panel and in an Import Profile after
 * "Load from File" alike.
 */
export function ImportWarningAlert({ warning }: { warning: OnlineImportWarning }) {
  const { t } = useTranslation();
  const text = warning.code === 'AmbiguousDate'
    ? t('onlineImport.warning.ambiguousDate', {
      defaultValue: '{{column}}: every date reads both as {{first}} and as {{second}}. Choose the transform yourself.',
      column: warning.column, first: warning.formats[0], second: warning.formats[1],
    })
    : t('onlineImport.warning.ambiguousDecimal', {
      defaultValue: '{{column}}: "{{example}}" can be read as a thousands separator or a decimal comma. Choose the transform yourself.',
      column: warning.column, example: warning.example,
    });
  return <Alert severity="warning">{text}</Alert>;
}
